module.exports = __webpack_public_path__ + "static/media/pharmacy_english.59a131a9.jpg";